import type { FormAddress } from '@innogy/common-ui/forms';
import { createAction, props } from '@ngrx/store';

const PREFIX = '[Heatpumps Wizard]';

export const heatpumpsWizardFormSubmitAction = createAction(
  `${PREFIX} Submit form`,
  props<{ payload: Partial<FormAddress> }>()
);
